<template>
  <pt-withdraw-audit class="pt-withdraw-audit__withData" :cityList="cityList" @withdrawalComplete="withdrawalComplete" ref="table"
  @withdrawalsExport="withdrawalsExport" :exportLoading="exportLoading" v-loading="loading"
  @addUserWalletBalance="addUserWalletBalance"></pt-withdraw-audit>
</template>

<script>
import PtWithdrawAudit from './index'
export default {
  name: 'pt-withdraw-audit__withData',
  components: {
    'pt-withdraw-audit': PtWithdrawAudit
  },
  data () {
    return {
      cityList: [],
      exportLoading: false,
      loading: false
    }
  },
  methods: {
    queryMerchantBalance () {
      this.$refs.table.queryMerchantBalance()
    },
    select () {
      this.$refs.table.select()
    },
    addUserWalletBalance (id) {
      let data = {
        withDrawLogId: id
      }
      this.loading = true
      this.$store.dispatch('addUserWalletBalance', data).then(res => {
        this.$message.success('回退数据成功')
        this.loading = false
        this.$refs.table.getWithdrawList()
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '回退数据失败')
      })
    },
    getAllCity () {
      this.$store.dispatch('getAllCity').then(res => {
        this.cityList = res
      }).catch(err => {
        this.$message.error(err || '获取所在地失败')
      })
    },
    withdrawalComplete (ids) {
      this.loading = true
      this.$store.dispatch('withdrawalComplete', ids).then(res => {
        this.$message.success('审核提现成功')
        this.loading = false
        this.queryMerchantBalance()
        this.$refs.table.getWithdrawList()
        this.select()
      }).catch(err => {
        this.loading = false
        this.$refs.table.getWithdrawList()
        this.select()
        this.$message.error(err || '审核提现失败')
      })
    },
    withdrawalsExport (val) {
      this.exportLoading = true
      this.$store.dispatch('withdrawalsExport', val).then(res => {
        this.exportLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出提现记录失败')
      })
    }
  },
  created () {
    this.getAllCity()
  }
}
</script>
